import { ControlBarButtonStyles, CameraButton, usePropsFor, useTheme } from '@azure/communication-react';
import React, { useCallback } from 'react';
import { CameraIconOff, CameraIconOn } from '../Icons';

interface ControlBarCameraButtonProps {
    styles?: ControlBarButtonStyles;
    disabled?: boolean;
}

export const ControlBarCameraButton = (props: ControlBarCameraButtonProps) => {
  const cameraProps = usePropsFor(CameraButton);
  const disabled = cameraProps.disabled || props.disabled;
  const themeV8 = useTheme();

  const onIconOn = useCallback(() => (
    <CameraIconOn disabled={disabled === true}/>
  ), [disabled, themeV8]);

  const onIconOff = useCallback(() => (
    <CameraIconOff disabled={disabled === true}/>
  ), [disabled, themeV8]);

  return (cameraProps &&
    <CameraButton
      {...cameraProps}
      disabled={disabled}
      onRenderOnIcon={onIconOn}
      onRenderOffIcon={onIconOff}
      showLabel={false}
      enableDeviceSelectionMenu={false}
      styles={props.styles}
  />)
}
